import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  DocuSignIntegrationConfig,
  DocuSignWebhookListener
} from '@dadohr/shared/domainTypes/integrations/docusign';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  CollectionListener,
  createCollectionListenerStore
} from '../../../../../../services/firecache/collectionListener';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toDocuSignConfigDoc = generateToDocFn<DocuSignIntegrationConfig>();

const COLLECTION = FS.docusignIntegrationConfig;
const collection = () => store().collection(COLLECTION);
export const docuSignConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toDocuSignConfigDoc
);

export const useDocuSignConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(docuSignConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<DocuSignIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            accessToken: '',
            refreshToken: '',
            accountId: '',
            baseUri: '',
            email: '',
            expiresAt: now(),

            webhook: {
              username: '',
              password: ''
            }
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeDocuSignConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

const toDocuSignWebhookListenerDoc = generateToDocFn<DocuSignWebhookListener>();
const DELIMITER = '|||||';
export const docuSignWebhookListenerStoreByInstance = createCollectionListenerStore(
  (key: string) => {
    const [orgId, instanceId] = key.split(DELIMITER);
    return new CollectionListener(
      store()
        .collection('docuSignWebhookListenerV1')
        .where('orgId', '==', orgId)
        .where('expId', '==', instanceId),
      toDocuSignWebhookListenerDoc
    );
  }
);

export const getDocuSignWebhookListenerByInstance = (
  orgId: string,
  instanceId: string
) => {
  return docuSignWebhookListenerStoreByInstance(
    [orgId, instanceId].join(DELIMITER)
  ).get();
};

export const getDocusignEnvelopeStatus = (
  orgId: string,
  instanceId: string,
  resourceId: string
): Promise<{
  envelopeId: string;
  status: 'unknown' | 'sent' | 'delivered' | 'completed' | 'signed';
}> => {
  return callFirebaseFunction('docusign_getEnvelopeStatus', {
    orgId,
    instanceId,
    resourceId
  });
};
